import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { SimpleModalComponent } from "ngx-simple-modal";
import { LinksComponent } from "../links.component";
import { LinkInfo } from "../links.model";
import { NmsDialogService } from "@nms-angular-toolkit/nms-dialog";
import { SelectLinksModalComponentModel } from "./select-links-modal.model";
import { ANGULARJS_TRANSLATE } from "@nms-ng2/app/shared/services/upgraded-provider/upgraded-providers";
import { OperatorType, RequestConfig, RequestFilter } from "@nms-angular-toolkit/nms-table";

/**
 * Componente de modal para seleção de Links.
 */
@Component({
    selector: "select-links-modal",
    templateUrl: "./select-links-modal.component.html",
    styleUrls: ["./select-links-modal.component.scss"]
})
export class SelectLinksModalComponent extends SimpleModalComponent<SelectLinksModalComponentModel, Array<LinkInfo>> implements
        SelectLinksModalComponentModel, OnInit {
    private readonly baseUrl: string = "web/topology/circuit/dwdm/options/search-links";

    @ViewChild(LinksComponent)
    linksComponent: LinksComponent;

    requestConfig: RequestConfig = {
        serverPagination: {
            baseUrl: this.baseUrl
        }
    };

    pageTitle: string;
    alreadySelectedLinksIds: number[] = [];
    filterResources: Object;
    filterParams: RequestFilter;
    operatorType: OperatorType

    constructor(private readonly nmsDialogService: NmsDialogService,
        @Inject(ANGULARJS_TRANSLATE) private readonly translate: any) {
        super();
    }

    ngOnInit(): void {
        this.result = [];
        this.requestConfig.serverPagination.filterParams = this.filterParams;
        this.requestConfig.serverPagination.operatorType = this.operatorType || "AND";
        this.requestConfig.extraParams = this.filterResources;
    }

    async addLinks(): Promise<void> {
        const selectedLinks = this.linksComponent.nmsTableComponent.selection.selected as LinkInfo[];
        if (selectedLinks.length === 0) {
            this.nmsDialogService.openDialog(
                {
                    title: this.translate.instant("popups.alert.error"),
                    description: this.translate.instant("table.links.no.item.selected"),
                    acceptLabel: "OK"
                }
            );

            return;
        }

        await this.verifyIfLinksAreAlreadyAdded(selectedLinks);
    }

    private async verifyIfLinksAreAlreadyAdded(selectedLinks: LinkInfo[]): Promise<void> {
        const alreadyAddedLinks = selectedLinks
            .filter((selectedLink) => this.alreadySelectedLinksIds.includes(selectedLink.id));

        if (alreadyAddedLinks.length > 0) {
            const message = this.translate.instant("select.links.modal.already.add.message");
            const duplicatedLinksNames = alreadyAddedLinks.map((link) => link.name).join("<br />");
            await this.nmsDialogService.openDialog(
                {
                    title: this.translate.instant("popups.alert.error"),
                    description: `${message}<br />${duplicatedLinksNames}`,
                    acceptLabel: "OK",
                    isConfirm: true,
                    bindHtml: true
                }
            ).then(() => {
                const alreadyAddedLinksIds = alreadyAddedLinks.map(link => link.id)
                this.linksComponent.nmsTableComponent.tableDataSource.data.forEach((row) => {
                    if (alreadyAddedLinksIds.includes(row.id)) {
                        this.linksComponent.nmsTableComponent.selection.deselect(row);
                        this.linksComponent.nmsTableComponent.detectChanges();
                    }
                });
            });
        } else {
            this.result = this.linksComponent.nmsTableComponent.selection.selected as LinkInfo[];
            this.close()
        }
    }
}
